import { CompareActionTypes } from '../../../enums/ActionEnums';
import { COMPARE_TRIGGERED_COMPONENT } from '../../../constants/CompareConstants';
const compareActions = {
    createAddAction(payload) {
        return {
            type: CompareActionTypes.COMPARE_ADD,
            payload,
        };
    },
    createInitAction(payload) {
        return {
            type: CompareActionTypes.COMPARE_INIT,
            payload,
        };
    },
    createCompareProductDisplayed() {
        return {
            type: CompareActionTypes.COMPARE_PAGE_PRODUCT_DISPLAYED,
        };
    },
    createCompareNoProductDisplayed() {
        return {
            type: CompareActionTypes.COMPARE_PAGE_NO_PRODUCT_DISPLAYED,
        };
    },
    createCompareProductDisplayedToggle(payload) {
        return {
            type: CompareActionTypes.COMPARE_PAGE_PRODUCT_DISPLAYED_TOGGLE,
            payload,
        };
    },
    createToggleLimitReachedAction(payload) {
        return {
            type: CompareActionTypes.COMPARE_TOGGLE_LIMIT_REACHED,
            payload,
        };
    },
    createRemoveAction(payload) {
        return {
            type: CompareActionTypes.COMPARE_REMOVE,
            payload,
        };
    },
    createUpdateOnListerAction(product) {
        return {
            type: CompareActionTypes.COMPARE_UPDATE,
            payload: {
                product,
                sourceComponent: COMPARE_TRIGGERED_COMPONENT.productLister,
            },
        };
    },
    createUpdateOnProductDetailPageAction(product) {
        return {
            type: CompareActionTypes.COMPARE_UPDATE,
            payload: {
                product,
                sourceComponent: COMPARE_TRIGGERED_COMPONENT.productDetail,
            },
        };
    },
    createUpdateInProductComparePageAction(product) {
        return {
            type: CompareActionTypes.COMPARE_UPDATE,
            payload: {
                product,
                sourceComponent: COMPARE_TRIGGERED_COMPONENT.comparePage,
            },
        };
    },
    createUpdateInProductCompareBoxAction(product) {
        return {
            type: CompareActionTypes.COMPARE_UPDATE,
            payload: {
                product,
                sourceComponent: COMPARE_TRIGGERED_COMPONENT.productCompareBox,
            },
        };
    },
    createUpdateProductsAction(payload) {
        return {
            type: CompareActionTypes.COMPARE_UPDATE_PRODUCTS,
            payload,
        };
    },
    createPopupCloseAction() {
        return {
            type: CompareActionTypes.COMPARE_POPUP_CLOSE,
        };
    },
    createPopupOpenAction() {
        return {
            type: CompareActionTypes.COMPARE_POPUP_OPEN,
        };
    },
    createPageOpenAction() {
        return {
            type: CompareActionTypes.COMPARE_PAGE_OPEN,
        };
    },
    createPopupToggleAction() {
        return {
            type: CompareActionTypes.COMPARE_POPUP_TOGGLE,
        };
    },
};
export default compareActions;
